export { useGetApplicationsWebPage } from './useGetApplicationsWebPage'
